<template>
  <div id="videos">
    <v-container class="mt-4" v-if="isVideoAdd">
      <v-form ref="formAdd">
        <v-layout wrap class="pb-3">
          <v-flex xs12 class="text-xs-right">
            <div class="d-inline-flex">
              <v-btn class="pf-btn pf-btn-cancel" @click="isVideoAdd = false;video.url = ''">
                <v-icon size="16" class="pr-1">cancel</v-icon>
                <div>Cancel</div>
              </v-btn>
              <v-btn class="pf-btn pf-btn-save mr-0" @click="save">
                <v-icon size="16" class="pr-1">check_circle</v-icon>
                <div>Save</div>
              </v-btn>
            </div>
          </v-flex>
        </v-layout>
        <v-layout wrap class="pt-3 pb-3">
          
          <v-flex xs12 sm12>
            <v-text-field label="Provide the video title"
                class="required" v-model.trim="video.name" :rules="[rules.titleRequired]"></v-text-field>
          </v-flex>
          <v-flex xs12 sm12>
            <v-select :items="categoryList" v-model="video.category" label="Category" class="required" required></v-select>
          </v-flex>
          <v-flex xs12 sm12>
            <v-select small-chips deletable-chips multiple :items="membershipList" :rules="membershipRules" v-model="video.membership" label="Membership" class="required" required></v-select>
          </v-flex>
          <v-flex xs12 sm12>
            <v-text-field label="Provide vimeo video link"
                class="required" v-model="video.url" :rules="[videoLinkRule]"></v-text-field>
          </v-flex>
        </v-layout>
      </v-form>
    </v-container>
    <v-container class="pa-0" v-if="!isVideoAdd">
      <v-layout>
        <v-flex class="xs12 sm12 mb-5">
          <v-btn fab absolute right class="mr-3 pf-btn-fab" @click="isVideoAdd = true">
            <v-icon>add</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-container>
    <v-form ref="formEdit">
    <v-container grid-list-md fluid v-if="helpVideoList.length > 0">
        <draggable v-model="helpVideoList" class="layout wrap row pb-4" handle=".handle" @start="drag=true" @end="dragReorder();drag=false">
          <v-flex xs12 sm6 md6 lg4 xl3 v-for="videoItem of helpVideoList" :key="videoItem.id" pa-2 >
            <v-card v-if="videoItem.url">
              <vue-plyr :options="options" v-if="videoItem.url.indexOf('vimeo.com') === -1">
                <div class="plyr__video-embed">
                  <iframe
                    :src="videoItem.url"
                    allowfullscreen
                    allowtransparency
                    allow="autoplay"
                  >
                  </iframe>
                </div>
              </vue-plyr>
              <vimeo-player v-else :video-url="videoItem.url" class="vimeo-embed-container" :options="{ responsive: true, controls: true, title: false }"></vimeo-player>
              
              <v-flex class="pl-1 pr-1 mb-0">
                <h5 v-if="isSave == false || currentEditor != videoItem.id" id="videoName" class="pa-1 title-display">
                  <div v-on:click="editItem(videoItem);">
                    <span v-if="videoItem.title && videoItem.title.trim() !== ''">{{ videoItem.title }}</span>
                    <span v-else>Add title here</span>
                  </div>
                </h5>
                <v-text-field
                  v-if="isSave && currentEditor == videoItem.id"
                  v-model.trim="videoItem.title"
                  autofocus
                  :hide-details="true"
                  class="pr-1 pt-1 text-edit-field" 
                  height="20" 
                  placeholder="Add title here"
                  @change="edit">
                </v-text-field>
              </v-flex>
              <v-flex class="pl-1 pr-1 mb-0">
                <h5 v-if="isSave == false || currentEditor != videoItem.id" id="videoName" class="pa-1 title-display">
                  <div v-on:click="editItem(videoItem);">
                    <span>Category: </span>
                    <span>{{ videoItem.category }}</span>
                  </div>
                </h5>
                <v-select v-if="isSave && currentEditor == videoItem.id" :items="categoryList" @change="edit" v-model="videoItem.category" class="pr-1 pt-1 required" required></v-select>
              </v-flex>
              <v-flex class="pl-1 pr-1 mb-0">
                <h5 v-if="isSave == false || currentEditor != videoItem.id" id="videoName" class="pa-1 title-display">
                  <div v-on:click="editItem(videoItem);">
                    <span>Membership: </span>
                    <span>{{ videoItem.membership.join(',') }}</span>
                  </div>
                </h5>
                <v-select small-chips deletable-chips multiple v-if="isSave && currentEditor == videoItem.id" :items="membershipList" @change="edit" v-model="videoItem.membership" class="pr-1 pt-1 required" required></v-select>
              </v-flex>
              <v-divider horizontal></v-divider>
              <v-flex flat class="text-xs-right pa-1">
                <v-btn icon title="Cancel Edit" class="ma-0 handle" v-show="isSave && currentEditor == videoItem.id" @click="canceledit">
                  <v-icon size="22" color="grey darken-2">cancel</v-icon>
                </v-btn>
                <v-btn icon title="Edit" class="ma-0" :disabled="isSave && currentEditor == videoItem.id" @click="editItem(videoItem, videoItem.id)">
                  <v-icon size="22" color="grey darken-2">edit</v-icon>
                </v-btn>
                <v-btn icon class="ma-0 handle">
                  <v-icon size="22" color="grey darken-2">open_with</v-icon>
                </v-btn>
                <v-btn icon class="ma-0" v-on:click="deleteItem(videoItem);">
                  <v-icon size="22" color="grey darken-2">delete_outline</v-icon>
                </v-btn>
              </v-flex>
            </v-card>
          </v-flex>
        <v-flex xs6 sm6>
        </v-flex>
      </draggable>
      <!--</v-layout>-->
    </v-container>
    <v-container grid-list-md fluid v-if="helpVideoList.length == 0 && !isVideoAdd" class="text-center">
        <img src="static/NoVideos.jpg" class="noItemsTemplate">
        <h4 class="pf-text-green"><b>No Video Found !! </b></h4>
    </v-container>
  </v-form>
  </div>
</template>
<script>
/* global session, store */
import UploadButton from 'vuetify-upload-button';
import draggable from 'vuedraggable';
import swal from 'sweetalert2';
import { getCollection, update, remove, create, updateSortList, getOne } from '../../helpers/helpers';
import Vue from 'vue';
import { mapGetters } from 'vuex';

import VuePlyr from 'vue-plyr';
import 'vue-plyr/dist/vue-plyr.css';
Vue.use(VuePlyr);

import { vueVimeoPlayer } from 'vue-vimeo-player';


// This lists and allows to handle the help videos to the admin
export default
{
  name: 'ListHelpVideosAdmin',
  components: {
    'upload-btn': UploadButton,
    draggable,
    'vimeo-player': vueVimeoPlayer
  },
  data: vm => ({
    entity: 'HelpVideo',
    options: {
      controls: ['play', 'progress', 'current-time', 'mute', 'fullscreen']
    },
    videoHeaders: [
      { text: 'Video', value: 'name', align: 'left' },
      { text: '', sortable: false },
    ],
    rules: {
      titleRequired: value => !!value.trim() || 'Field is required.',
    },
    editData: {},
    editItemData: {
      helpVideoList: {
        index: -1,
        data: {}
      }
    },
    video: {
      name: '', url: '', size: '', category: 'General', membership: []
    },
    isSave: false,
    currentEditor: null,
    currentEditorIndex: null,
    isVideoAdd: false,
    dialog: false,
    // homeVideo: 1,
    selectedFileItem: {},
    tempVideoLink: null,
    isVideoLinkValidated: false,
    categoryList: [
      'General',
      'Messaging',
      'Pictures',
      'Profile Document',
      'Video Project',
      'Videos',
    ],
    membershipList: [
      'Network',
      'Featured',
      'Preferred'
    ],
    membershipRules: [
      v => v.length > 0 || 'membership is required'
    ]
  }),
  computed: {
    ...mapGetters([]),
    helpVideoList: {
      get () {
        return store.state.VideoList;
      },
      set (value) {
        store.commit('setVideoList', value);
      }
    }
  },
  beforeRouteEnter (to, from, next) {
    if (!session.isOnline()) {
      next({ path: '/login' });
    } else {
      next();
    }
  },
  beforeRouteLeave (to, from, next) {
    if (!this.isSave) {
      next();
    } else {
      swal.fire({
        type: 'warning',
        title: 'title is required.',
        text: 'Please add title',
        showConfirmButton: true,
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'OK'
      });
      return;
    }
  },
  created () {
    this.initialize();
  },
  methods: {
    async dragReorder () {
      let result = await this.helpVideoList.map(function (video, index) {
        let o = Object.assign({}, video);
        o.sort_no = index + 1;
        return o;
      });
      let totalResult = [...result];
      this.updateSorting(totalResult);
      this.helpVideoList = totalResult;
    },
    async updateSorting (result) {
      for (let i = 0; i < result.length; i++) {
        let video = { ...result[i] };
        let { error, data } = await update(this.entity, video, video.id);
        if (error) {
          console.log(error);
        }
      }
    },
    // @vuese
    // Used to validate if the video is vimeo
    // @arg The video URL
    videoLinkRule (url) {
      if (!this.isVideoLinkValidated) {
        if (url !== undefined || url !== '') {
          let regExp2 = /(?:https?:\/\/(?:www\.)?)?vimeo.com\/(?:channels\/|groups\/([^\/]*)\/videos\/|album\/(\d+)\/video\/|)(\d+)(?:$|\/|\?)/;
          let match2 = url.match(regExp2);
          if (match2) {
            this.tempVideoLink = 'https://player.vimeo.com/video/' + match2[3];
            return false;
          } else {
            return 'Please enter a vimeo video url';
          }
        }
      } else {
        return false;
      }
    },
    // @vuese
    // Used to fetch the video list if not exists already
    async initialize () {
      if (!this.helpVideoList.length) {
        let sort = { sort_no: 1 };
        let { error, data } = await getCollection(this.entity, true, 0, '', {}, null, null, sort);
        if (error) {
          console.log(error);
        } else {
          if (data.length > 0) {
            this.helpVideoList = data;
          }
        }
      }
    },
    // @vuese
    // Used to save the new help video
    async save () {
      if (this.$refs.formAdd.validate()) {
        this.isVideoAdd = false;
        let length = 0;
        if (this.helpVideoList.length) {
          length = Math.max.apply(null, this.helpVideoList.map(item => item.sort_no));
        }
        let postData = {
          title: this.video.name,
          description: 'HelpVideo 1',
          category: this.video.category,
          url: this.tempVideoLink,
          membership: this.video.membership,
          sort_no: length + 1
        };
        let { error, data } = await create(this.entity, postData);
        if (error) {
          this.isVideoAdd = true;
          console.log('error', error);
        } else {
          this.loading = false;
          this.helpVideoList.push(data);
          swal.fire({
            type: 'success',
            title: 'Video added successfully',
            showConfirmButton: false,
            timer: 2500,
            onClose: () => {
              this.video.url = '';
              this.video.name = '';
              this.isVideoAdd = false;
              this.tempVideoLink = null;
              this.isVideoLinkValidated = false;
            }
          });
        }
      }
    },
    // @vuese
    // Used to setup to edit the video
    // @arg The video item object to be edited
    editItem (item) {
      this.currentEditor = item.id;
      this.isSave = true;
      this.editData = item;
      this.currentEditorIndex = this.helpVideoList.indexOf(item);
    },

    // reset the edit variables
    canceledit () {
      this.isSave = false;
      this.currentEditor = null;
      this.currentEditorIndex = null;
      this.editData = {};
    },
    // @vuese
    // Used to save the edited video details
    async edit () {
      if (this.$refs.formEdit.validate()) {
        if (!this.editData.title) {
          swal.fire({
            type: 'warning',
            title: 'title is required.',
            text: 'Please add title',
            showConfirmButton: true,
            confirmButtonColor: '#3085d6',
            confirmButtonText: 'OK'
          });
          return;
        }
        if (!this.editData.membership.length) {
          swal.fire({
            type: 'warning',
            title: 'Membership is required.',
            text: 'Please add Membership',
            showConfirmButton: true,
            confirmButtonColor: '#3085d6',
            confirmButtonText: 'OK'
          });
          return;
        }
        let { error, data, status } = await update(this.entity, this.editData, this.editData.id);
        if (error) {
          console.log('error', error);
        } else {
          this.helpVideoList[this.currentEditorIndex] = data;
          this.loading = false;
          swal.fire({
            type: 'success',
            title: 'Video updated successfully',
            showConfirmButton: false,
            timer: 2500,
            onClose: () => {
              this.helpVideoList[this.currentEditorIndex].id = this.currentEditor;
              this.currentEditor = null;
              this.currentEditorIndex = null;
              this.isSave = false;
            }
          });
        }
      }
    },
    // @vuese
    // Used to delete the help video
    // @arg The video object to be deleted
    deleteItem (item) {
      if (item.id) {
        swal.fire({
          title: 'Are you sure?',
          text: "You won't be able to revert this!",
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
          if (result.value) {
            (async () => {
              let { error, data, status } = await remove(this.entity, item.id);
              if (error) {
                console.log('error', error);
              } else {
                const index = this.helpVideoList.indexOf(item);
                this.helpVideoList.splice(index, 1);
                swal.fire(
                  'Deleted!',
                  'The video "' + item.title + '" has been deleted.',
                  'success'
                );
              }
            })();
          }
        });
      }
    }
  }
};
</script>

<style lang="stylus" scoped>
  .pf-divider {
    margin: 0 auto;
    width: 88%;
  }
  .upload-container{
    padding-top: 10px;
  }
  .pf-video-upload-btn{
    padding-left: 0;
    padding-right: 0;
  }
  .or-label{
    padding-top: 28px;
  }
  .title-display{
    padding-top: 6px !important;
  }
  .text-edit-field {
    padding-left: 4px;
    padding-bottom: 6px;
  }
  @media(max-width:576px){
    .or-label{
      padding-top: 0;
    }
  }
  
</style>



// WEBPACK FOOTER //
// src/pages/HelpVideos/AdminList.vue